import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  PageTitle,
  PageSubtitle,
  TooltipHintWrapper,
  PageSubtitleWrapper,
} from "flow/SiteProposal/pages/About/style";
import Tooltip from "components/Tooltip";
import InfoIcon from "assets/icons/info-icon";

import TriggerSpeciesTab from "./TriggerSpeciesTab";
import TriggerEcosystemsTab from "./TriggerEcosystemsTab";
import AddDetailsEffectTab from "./AddDetailsEffectTab";

import {
  TabsInner,
  TabItem,
  TabUnderline,
  DividerLine,
  ContentContainer,
} from "./style";
import { RemoveItemModalFooter, RemoveItemModalText } from 'flow/SiteMonitoring/pages/Pressure/component/style'
import Button from 'components/Button'
import Modal from 'components/Modal'
import Container from 'components/Container'

function PressureDetailsForm(props) {
  const { threatItemId, titleValue, triggerItem, modalTitleId, totalTriggers, onCancel, onBackToPressure, setIsModalOpen  } = props || {}
  const [mainTab, setMainTab] = useState("select");
  const [subTab, setSubTab] = useState(props.parentTabSelected || "species");
  const [incomingSelection, setIncomingSelection] = useState([]);
  const [speciesCount, setSpeciesCount] = useState(0);
  const [ecosystemsCount, setEcosystemsCount] = useState(0);
  const [showTabWarning, setShowTabWarning] = useState(false)
  useEffect(() => {
    if (props.parentTabSelected) {
      setSubTab(props.parentTabSelected)
    }
  }, [props.parentTabSelected])

  const EffectDetailsPage = () => (
    <div style={{ padding: 0 }}>
      <AddDetailsEffectTab
        preselectedItems={incomingSelection}
        setIncomingSelection={setIncomingSelection}
        setMainTab={setMainTab}
        setEcosystemsCount={setEcosystemsCount}
        selectedSubTab={(tab) => {
          setSubTab(tab)
          notifyParent(tab)
        }}
        parentTabSelected={subTab}
        onCancel={onCancel}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  )

  const notifyParent = (tab) => {
    if (typeof props.selectedSubTab === 'function') {
      props.selectedSubTab(tab)
    }
  }

  const handleSpeciesTabClick = (e) => {
    if(e > 0) {
      setShowTabWarning(true)
      return
    }
    setSubTab("species");
    notifyParent("species")
  }

  const handleEcosystemsTabClick = (e) => {
    if(e > 0) {
      setShowTabWarning(true)
      return
    }
    setSubTab("ecosystems");
    notifyParent("ecosystems")
  }

  return (
    <div>
      {/* Heading */}
      <PageTitle style={{ marginTop: "35px" }}>
        <FormattedMessage id="pressureTriggerTitle" />
      </PageTitle>

      <PageSubtitleWrapper>
        <PageSubtitle>
          <FormattedMessage id="pressureTriggerSubTitle" />
        </PageSubtitle>
        <Tooltip
          placement="bottom"
          trigger={["hover"]}
          align={{ offset: [0, 16] }}
          zIndex={9999}
          overlay={{
            label: "threatTitle",
            infoTooltip: "threaInfoToolTip",
          }}
          type="big"
        >
          <TooltipHintWrapper>
            <InfoIcon />
          </TooltipHintWrapper>
        </Tooltip>
      </PageSubtitleWrapper>

      {/* Tab content */}
      <ContentContainer>
        {mainTab === 'select' ? (
          <div>
            <Container>
              <div style={{ margin: "0 30px" }}>
              <TabsInner style={{ marginBottom: 0, marginTop: "36px" }}>
                <TabItem isActive={subTab === "species"} onClick={() => handleSpeciesTabClick(ecosystemsCount)} className='active'>
                  <FormattedMessage id='species' /> | <span>{speciesCount}</span>&nbsp;<FormattedMessage id="selected" />
                  {subTab === "species" && <TabUnderline />}
                </TabItem>
                <TabItem isActive={subTab === "ecosystems"} onClick={() => handleEcosystemsTabClick(speciesCount)}>
                  <FormattedMessage id='ecosystems' /> | <span>{ecosystemsCount}</span> <FormattedMessage id="selected" />
                  {subTab === "ecosystems" && <TabUnderline />}
                </TabItem>
              </TabsInner>
              <DividerLine />
              </div>
            </Container>

            {subTab === "species" ? (
                <TriggerSpeciesTab
                  onAddToEffect={(items) => {
                    setSubTab('species')
                    notifyParent('species')
                    setIncomingSelection(items);
                    setMainTab('add');
                    if (typeof props.onCancel === 'function') props.onCancel()
                  }}
                  threatItemId={threatItemId}
                  onSelectionChange={({ species }) => setSpeciesCount(species || 0)}
                  titleValue={titleValue || modalTitleId}
                  modalTitleId={modalTitleId}
                  totalTriggers={totalTriggers || false}
                  onCancel={props.onCancel}
                  onBackToPressure={onBackToPressure}
                />
            ) : (
              <TriggerEcosystemsTab
                onAddToEffect={(items) => {
                  setSubTab('ecosystems')
                  notifyParent('ecosystems')
                  setIncomingSelection(items);
                  setMainTab('add');
                  if (typeof props.onCancel === 'function') props.onCancel()
                }}
                threatItemId={threatItemId}
                onSelectionChange={({ ecosystems }) => setEcosystemsCount(ecosystems || 0)}
                titleValue={titleValue}
                modalTitleId={modalTitleId}
                totalTriggers={totalTriggers || false}
                onCancel={props.onCancel}
              />
            )}
          </div>
        ) : (
          <EffectDetailsPage />
        )}
        <Modal
          width="416px"
          zIndex={99999}
          isOpen={showTabWarning}
          toggleModal={() => setShowTabWarning(false)}
          modalTitleId="Attention"
          bottomBorder={true}
        >
          <RemoveItemModalText data-test="modal-body">
            <FormattedMessage
              id="addSpeciesBeforeEcosystems"
              values={{
                type: <b>{subTab === 'species' ? 'species' : 'ecosystem'}</b>,
                type2: <b>{subTab === 'species' ? 'ecosystem' : 'species'}</b>
              }}
            />
          </RemoveItemModalText>

          <RemoveItemModalFooter>
            <Button type="secondary" onClick={() => setShowTabWarning(false)}>
              <FormattedMessage id="okay" />
            </Button>
          </RemoveItemModalFooter>
        </Modal>
      </ContentContainer>
    </div>
  );
}

export default PressureDetailsForm;
